import clsx from 'clsx';

interface SkeletonProps {
	className?: string;
}

export const Skeleton = ({ className }: SkeletonProps) => {
	return (
		<div
			className={clsx(
				'w-full max-w-[500px] bg-neutral-100 rounded-lg h-12 animate-pulse',
				className,
			)}
		/>
	);
};
